




















































import { computed, defineComponent, PropType, toRefs } from '@vue/composition-api';
import QuestionTooltip from '@/components/common/question-tooltip/index.vue';
import SelectIcon from '@tt4b/ttam-assets/src/svgs/objective-select.svg?url';
import { TypeSelectItem } from '../types';

const name = 'ttam-identity-tiktok-type-select-item';

export default defineComponent({
  name,
  components: { QuestionTooltip },
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    disabledTips: {
      type: String,
      default: '',
    },
    // 竞价使用本组件传入iconClass属性
    data: {
      type: Object as PropType<TypeSelectItem>,
      default: () => ({}),
    },
  },
  setup(props, { emit }) {
    const { active, disabled, data } = toRefs(props);

    const icon = computed(() => (active.value ? SelectIcon : data.value?.icon));
    return {
      name,
      icon,
      SelectIcon,
    };
  },
});
